import { FC, Fragment, useState } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Models
import { RootState } from 'app/store';
// Selectors
import { selectDocumentsAsOptions } from 'app/store/DMSDocuments/DMSDocuments.selectors';
// MUI
import { Box } from '@mui/material';
// Components
import Dialog from 'app/components/Dialog';
import { Button } from 'app/components/Mui';
import { Autocomplete } from 'app/components/Mui/Autocompletes';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (documentIds:any) => void;
}

const WorkflowDialog:FC<Props> = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();

  const documentOptions = useAppSelector((state:RootState) => selectDocumentsAsOptions(state, { excludeCustomFormat: false, onlyOcred: true }));

  const [selectedDocumentIds, setSelectedDocumentIds] = useState<number[]>([]);

  const selectAllDocuments = () => {
    setSelectedDocumentIds(documentOptions.map((doc) => doc.value));
  }

  const onChange = (nextValue:any) => {
    setSelectedDocumentIds(nextValue);
  }

  const isDisabled = selectedDocumentIds.length === 0;

  const actions = (
    <Fragment>
      <Button
        name="Close workflow dialog"
        onClick={onClose}
      >{t('buttons.close')}</Button>
      <Button
        name="Run workflow"
        variant="contained"
        color="primary"
        disabled={isDisabled}
        onClick={onSubmit(selectedDocumentIds)}
      >{t('buttons.run')}</Button>
    </Fragment>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      title={t('dialogs.workflow.title')}
      actions={actions}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Autocomplete
          value={selectedDocumentIds}
          onChange={onChange}
          options={documentOptions}
          TextFieldProps={{
            label: t('labels.documents')
          }}
          multiple
          filterSelectedOptions
          getOptionLabel={(option:any) => option.label}
          limitTags={4}
        />
        <Button
          name="Select all documents"
          variant="contained"
          size="large"
          onClick={selectAllDocuments}
        >{t('buttons.all')}</Button>
      </Box>
    </Dialog>
  )
}

export default WorkflowDialog;